import classnames from 'classnames';

import { RestrictedAccess } from 'lib/restrictedAccess';
import React, { Fragment, HTMLAttributes, ReactNode } from 'react';
import { Button, Grid, GridCell } from 'v1/components/shared';

import './SettingsSection.scss';

interface ActionProps {
  onClick?: () => void;
  text?: string;
  className?: string;
  type?: 'button' | 'submit';
  capability?: string;
  render?: () => ReactNode;
}

interface SettingsSectionProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  primaryAction?: ActionProps;
  secondaryAction?: ActionProps; // note: even though PropTypes originally did not include "render" for secondaryAction, we're allowing it here for consistency with rendering logic
  renderActions?: ReactNode;
  className?: string;
  children?: ReactNode;
  outsideStyles?: boolean;
}

const SettingsSection = ({
  title,
  description,
  primaryAction,
  secondaryAction,
  renderActions,
  className,
  children,
  outsideStyles = true,
  ...props
}: SettingsSectionProps) => {
  return (
    <div
      className={classnames(
        'SettingsSection',
        { 'SettingsSection--outsideStyles': outsideStyles },
        className
      )}
      {...props}
    >
      <Grid gutters="M" spread className="stack-M">
        {/* @ts-expect-error todo migrate to ts */}
        <GridCell style={{ alignSelf: 'center' }}>
          {title && <h3>{title}</h3>}
          {description}
        </GridCell>
        <GridCell width="auto">
          {renderActions ? (
            renderActions
          ) : (
            <Fragment>
              {secondaryAction &&
                (secondaryAction.render ? (
                  secondaryAction.render()
                ) : (
                  <Button
                    onClick={secondaryAction.onClick}
                    className={secondaryAction.className}
                    type={secondaryAction.type || 'button'}
                  >
                    {secondaryAction.text}
                  </Button>
                ))}
              {primaryAction && (
                // @ts-expect-error todo migrate to ts
                <RestrictedAccess capabilities={primaryAction.capability}>
                  {primaryAction.render ? (
                    primaryAction.render()
                  ) : (
                    <Button
                      onClick={primaryAction.onClick}
                      className={primaryAction.className}
                      type={primaryAction.type || 'button'}
                    >
                      {primaryAction.text}
                    </Button>
                  )}
                </RestrictedAccess>
              )}
            </Fragment>
          )}
        </GridCell>
      </Grid>
      <div className="SettingsSection-content">{children}</div>
    </div>
  );
};

export default SettingsSection;
